import { mapToTrackableProduct } from '@utils/gtm-tracking/utils/mapToTrackableProduct';
import { ProductSearchViewModel } from '@models/api-search.models';
import { PromotionCreativeName, PromotionSettings } from '@utils/gtm-tracking/model/Promotion';

// Generate creative_slot position name
const creativeSlotPosition = (slot: string, index: number): string => {
    return index ? `${slot} (${index})` : `${slot}`;
}

// Generate creative_slot name
const creativeSlot = (creativeName: PromotionCreativeName = 'USP Spot - Unknown', index: number, slot: string = ''): string => `${creativeSlotPosition(slot, index)} - ${creativeName}`;

/**
 * Generate promotion object this is not considered as a normal promotion, but former extend recommend using this for
 * tracking the usp card impression in the middle of the PLP, that is why some fields could be hardcoded
 * @param promoSetting
 * @param product
 */
export const generatePromotion = (promoSetting: PromotionSettings, product?: ProductSearchViewModel) => ({
    ...(promoSetting ? {
        creative_name: promoSetting.creative_name,
        creative_slot: creativeSlot(promoSetting.creative_name, promoSetting.index, promoSetting.creative_slot),
        promotion_id: promoSetting.promotion_id?.length ? promoSetting.promotion_id : 'app-product-usp-card',
        promotion_name: promoSetting.promotion_name
    } : {}),
    ...(product?.length ? {items: [mapToTrackableProduct(product)]} : {})
})
